export const FilterType = {
  AsyncList: 'AsyncList',
  List: 'List',
  DateRange: 'DateRange',
  TimeRange: 'TimeRange',
  BusinessUnit: 'BusinessUnit',
  Select: 'Select',
  Unknown: 'Unknown'
}
